"use strict";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--foreground-tooltip, var(--white));\n  border-radius: 6px;\n  box-shadow: var(--elevation-300, var(--level-3));\n  font-size: var(--font-size-small, var(--x-small));\n  pointer-events: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--noreaster);\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  color: var(--pleather);\n  font-weight: var(--bold);\n  padding: 8px 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0px 8px 8px 0px;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  grid-column: 1 / 3;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  grid-column: 3 / 4;\n  text-align: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: grid;\n  gap: 12px;\n  padding: 12px 24px 12px 24px;\n  grid-template-columns: auto auto auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: normal;\n  max-height: 3.4em;\n  line-height: 1.4em;\n  margin: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 8px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 250px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--bold);\n  text-align: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--smurf-blood);\n  border-color: var(--smurf-blood);\n  border-radius: 6px;\n  color: var(--white);\n  font-weight: var(--normal);\n  font-size: var(--x-small);\n  line-height: 1.5;\n  padding: 10px 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 6px;\n  box-shadow: var(--level-3);\n  font-size: var(--x-small);\n  background-color: #fff;\n  pointer-events: auto;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--tooltip-header-bg);\n  color: var(--tooltip-header-color);\n  border-radius: 6px 6px 0 0;\n  padding: 8px 24px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--bold);\n  font-size: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    Chart: function() {
        return Chart;
    },
    TooltipHeader: function() {
        return TooltipHeader;
    },
    TooltipTitle: function() {
        return TooltipTitle;
    },
    TooltipWrapper: function() {
        return TooltipWrapper;
    }
});
module.exports = __toCommonJS(src_exports);
// src/Chart.tsx
var import_react2 = require("react");
var import_server2 = require("react-dom/server");
var import_lodash = __toESM(require("lodash.merge"));
var import_highcharts = __toESM(require("highcharts"));
var import_stock = __toESM(require("highcharts/modules/stock"));
var import_accessibility = __toESM(require("highcharts/modules/accessibility"));
var import_highcharts_react_official = __toESM(require("highcharts-react-official"));
// src/ChartTooltip.tsx
var import_react = require("react");
var import_server = require("react-dom/server");
var import_styled_components = __toESM(require("styled-components"));
var import_legacy_components = require("@studio/legacy-components");
// src/date.ts
var import_moment = __toESM(require("moment"));
import_moment.default.suppressDeprecationWarnings = true;
var format = function(date, tokens) {
    return (0, import_moment.default)(date).format(tokens);
};
var utc = function(date) {
    return (0, import_moment.default)(date).utc();
};
// src/ChartTooltip.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Wrapper = import_styled_components.default.div(_templateObject());
var Title = import_styled_components.default.div(_templateObject1());
var GridItem = import_styled_components.default.div(_templateObject2());
var NameHeader = (0, import_styled_components.default)(GridItem)(_templateObject3());
var ValueHeader = (0, import_styled_components.default)(GridItem)(_templateObject4());
var Points = import_styled_components.default.div(_templateObject5());
var Clamp = import_styled_components.default.p(_templateObject6());
var Marker = (0, import_styled_components.default)(import_legacy_components.Icon)(_templateObject7(), function(param) {
    var color = param.color;
    return color;
});
var Name = import_styled_components.default.span(_templateObject8());
var Value = import_styled_components.default.span(_templateObject9(), function(param) {
    var hasHeader = param.hasHeader;
    return hasHeader ? "center" : "right";
});
var SimpleTooltip = import_styled_components.default.div(_templateObject10());
var number = function(value) {
    return new Intl.NumberFormat().format(value);
};
function ChartTooltip(param) {
    var points = param.points, publishInfo = param.publishInfo, x = param.x, _headers = param.headers, headers = _headers === void 0 ? [
        "",
        ""
    ] : _headers;
    var title = format(utc(x), "dddd, MMM D, YYYY");
    var _headers1 = _slicedToArray(headers, 2), nameHeader = _headers1[0], valueHeader = _headers1[1];
    return points ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Title, {
                children: title
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Points, {
                children: [
                    nameHeader && valueHeader && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameHeader, {
                                children: nameHeader
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ValueHeader, {
                                children: valueHeader
                            })
                        ]
                    }),
                    points.map(function(_param) /* @__PURE__ */ {
                        var color = _param.color, name = _param.series.name, _point = _param.point, value = _point.y, point = _objectWithoutProperties(_param, [
                            "color",
                            "series",
                            "point"
                        ]);
                        return (0, import_jsx_runtime.jsxs)(import_react.Fragment, {
                            children: [
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Marker, {
                                    color: color,
                                    icon: "circle"
                                }),
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Name, {
                                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Clamp, {
                                        children: name
                                    })
                                }),
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Value, {
                                    hasHeader: Boolean(valueHeader),
                                    children: number(value)
                                })
                            ]
                        }, point.x);
                    })
                ]
            })
        ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SimpleTooltip, {
        children: publishInfo
    });
}
// src/Chart.tsx
var import_jsx_runtime = require("react/jsx-runtime");
(0, import_stock.default)(import_highcharts.default);
(0, import_accessibility.default)(import_highcharts.default);
var container = {
    style: {
        height: "100%",
        width: "100%"
    }
};
var base = {
    chart: {
        animation: false,
        height: 400,
        style: {
            fontFamily: "Mulish, Helvetica Neue, sans-serif"
        }
    },
    colors: [
        "#9D9DFF",
        "#FF97BC",
        "#6FDDDB",
        "#FFBB61"
    ],
    credits: {
        enabled: false
    },
    legend: {
        align: "left",
        margin: 24,
        itemDistance: 16,
        itemHiddenStyle: {
            color: "var(--text-tertiary)"
        },
        itemHoverStyle: {
            color: "var(--text-secondary)"
        },
        itemStyle: {
            color: "var(--text-primary)"
        },
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 6,
        verticalAlign: "top"
    },
    plotOptions: {
        series: {
            animation: false,
            marker: {
                symbol: "circle"
            }
        }
    },
    time: {
        useUTC: true
    },
    title: {
        text: void 0
    },
    tooltip: {
        padding: 12,
        shared: true,
        useHTML: true,
        borderWidth: 0,
        backgroundColor: "none",
        shadow: false,
        positioner: function positioner(labelWidth, labelHeight, point) {
            var _chart = this.chart, chartPlotLeft = _chart.plotLeft, chartPlotTop = _chart.plotTop, chartPlotWidth = _chart.plotWidth, chartHeight = _chart.chartHeight, hoverPoint = _chart.hoverPoint;
            var type = hoverPoint.series.type;
            var plotX = point.plotX, plotY = point.plotY;
            var tooltipLeftX = chartPlotLeft + plotX - labelWidth;
            var tooltipRightX = chartPlotLeft + plotX;
            var tooltipY = chartPlotTop + plotY - labelHeight / 2;
            if (tooltipY < 0) {
                tooltipY -= tooltipY;
            }
            if (tooltipY + labelHeight > chartHeight) {
                tooltipY -= chartPlotTop + chartHeight - (tooltipY + labelHeight);
            }
            if (type === "flags") {
                tooltipY -= 126;
            }
            return {
                x: tooltipRightX + labelWidth > chartPlotLeft + chartPlotWidth ? tooltipLeftX : tooltipRightX,
                y: tooltipY
            };
        }
    },
    xAxis: {
        dateTimeLabelFormats: {
            day: "%b %e",
            week: "%b %e",
            month: "%b '%y"
        },
        title: {
            margin: 16,
            style: {
                color: "var(--text-primary)",
                fontWeight: "var(--semi-bold)"
            },
            text: "Date"
        },
        type: "datetime"
    },
    yAxis: {
        allowDecimals: false,
        height: "90%",
        top: "10%",
        min: 0,
        minRange: 1,
        title: {
            margin: 12,
            style: {
                color: "var(--text-primary)",
                fontWeight: "var(--semi-bold)"
            },
            text: "Count"
        }
    }
};
function Chart(param) {
    var overrides = param.options, series = param.series, tooltipHeaders = param.tooltipHeaders;
    var formatter = (0, import_react2.useCallback)(function renderTooltip() {
        var ref = this, key = ref.key, points = ref.points, x = ref.x;
        return (0, import_server2.renderToStaticMarkup)(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(ChartTooltip, {
            publishInfo: "".concat(key),
            points: points,
            x: x,
            headers: tooltipHeaders
        }));
    }, [
        tooltipHeaders
    ]);
    var options = (0, import_react2.useMemo)(function() {
        var merged = (0, import_lodash.default)({}, base, {
            tooltip: {
                formatter: formatter
            }
        }, overrides);
        return _objectSpreadProps(_objectSpread({}, merged), {
            series: series
        });
    }, [
        overrides,
        series,
        formatter
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_highcharts_react_official.default, {
        containerProps: container,
        highcharts: import_highcharts.default,
        options: options
    });
}
// src/Tooltip.tsx
var import_styled_components2 = __toESM(require("styled-components"));
var TooltipWrapper = import_styled_components2.default.div(_templateObject11());
var TooltipHeader = import_styled_components2.default.div(_templateObject12());
var TooltipTitle = import_styled_components2.default.h3(_templateObject13(), function(param) {
    var size = param.size;
    switch(size){
        case "xxs":
            return "var(--xx-small)";
        case "xs":
            return "var(--x-small)";
        case "s":
            return "var(--small)";
        case "m":
            return "var(--regular)";
        case "ml":
            return "var(--medium-large)";
        case "l":
            return "var(--large)";
        case "xl":
            return "var(--x-large)";
        case "xxl":
            return "var(--x-large)";
        default:
            return "var(--regular)";
    }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    Chart: Chart,
    TooltipHeader: TooltipHeader,
    TooltipTitle: TooltipTitle,
    TooltipWrapper: TooltipWrapper
});
//# sourceMappingURL=index.js.map